module.exports = __webpack_public_path__ + "img/icon-dot.e285b5a7.svg";